'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutContainer, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { FaqSeo } from '@libs/common-next';
import { parseRichContentToPlainText } from '../../../utils/parseRichText';
import { useFaqColumns } from './columns.hook';
import { FaqAccordionGroup } from './faq-accordion-group';
import type { FaqProps } from './types';
import './styles.scss';
export type { FaqProps } from './types';
export function Faq(t0) {
  const $ = _c(20);
  const {
    heading,
    description,
    items,
    columns,
    className
  } = t0;
  const hasStoreCards = items.some(_temp);
  let t1;
  if ($[0] !== items) {
    t1 = items.flatMap(_temp2);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const seoItems = t1;
  const columnStyle = useFaqColumns(items.length, columns);
  const T0 = LayoutContainer;
  const t2 = "sparky-u-width-100";
  const t3 = cn("faq", className, {
    "faq-centered": hasStoreCards,
    "faq-columns": columnStyle
  });
  let t4;
  if ($[2] !== heading) {
    t4 = <Heading size="title" tagName="h2">{heading}</Heading>;
    $[2] = heading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description) {
    t5 = description && <TextPassage className="faq-subheader">{description}</TextPassage>;
    $[4] = description;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== items) {
    t6 = items.length > 0 && <FaqAccordionGroup items={items} />;
    $[6] = items;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== seoItems) {
    t7 = <FaqSeo id="faq-seo" qaArray={seoItems} />;
    $[8] = seoItems;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== columnStyle || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t3} style={columnStyle}>{t4}{t5}{t6}{t7}</div>;
    $[10] = columnStyle;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== T0 || $[18] !== t8) {
    t9 = <T0 className={t2}>{t8}</T0>;
    $[17] = T0;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp2(t0) {
  const {
    title,
    content
  } = t0;
  if (content.type !== "rich-text") {
    return [];
  }
  return [{
    question: title,
    answer: parseRichContentToPlainText(content.document)
  }];
}
function _temp(item) {
  return item.content.type === "stores";
}